<template>
  <div>
    <el-dialog
      class="views-bulletin-components-layout-template"
      width="50%"
      title="版型"
      :visible.sync="isDialogVisible"
      destroy-on-close
    >
      <div class="views-bulletin-components-layout-template__title">
        名稱：{{ title }}
      </div>
      <div class="views-bulletin-components-layout-template__title">
        版型支援內容：{{ content.join("、") }}
      </div>
      <div class="views-bulletin-components-layout-template__image-wrapper">
        <img
          :src="image"
          class="views-bulletin-components-layout-template__image"
          alt="版型預覽"
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: () => ({})
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: Array,
      default: () => []
    },
    image: {
      type: String,
      default: ''
    }
  },
  computed: {
    isDialogVisible: {
      get () {
        return this.isVisible
      },
      set (value) {
        this.$emit('update:isVisible', value)
      }
    }
  }
}
</script>

<style lang="sass">
.views-bulletin-components-layout-template .el-dialog
  border-radius: $pageBorderRadius
  &__header
    border-top-left-radius: $pageBorderRadius
    border-top-right-radius: $pageBorderRadius
    background-color: $bgDark3
  &__title
    color: $mainFontColor
    font-size: map-get($fontSize,large)
    font-weight: bold
    line-height: 32px
  &__close
    font-size: 25px
    font-weight: bolder
    color: $subFontColor
  &__body
    display: flex
    flex-direction: column
    justify-content: center
    font-size: map-get($fontSize,small)
    padding: 35px 40px

.views-bulletin-components-layout-template__title
  display: flex
  font-size: 20px
  font-weight: bold
  margin-bottom: 20px
  line-height: 1.2

.views-bulletin-components-layout-template__image-wrapper
  display: flex
  justify-content: center
  margin-bottom: 20px
  width: 100%
  height: 100%

.views-bulletin-components-layout-template__image
  width: 100%
  max-width: 420px
  height: 100%
  object-fit: cover
</style>
